import $ from "jquery";
import "selectize";

import "./plugins/multiple-select-remove-button";
import "./plugins/multiple-select-toggle-option";
import "./plugins/multiple-select-items-wrap";

export class Select {
  constructor() {}

  fillupAccount = (options) => {
    $("#fillup-account-payment-method").selectize({
      options: options,
      render: {
        option(item, escape) {
          return `
                        <div class="fillup-account__payment-method-option option">
                            <span class="fillup-account__payment-method-option-icon">
                                <img src=${escape(item.icon)} alt=${escape(
            item.name
          )}>
                            </span>
                            <span class="fillup-account__payment-method-option-text">${escape(
                              item.name
                            )}</span>
                        </div>
                    `;
        },
        item(item, escape) {
          return `
                        <div class="fill-account__payment-method-item">
                            <span class="fillup-account__payment-method-item-icon">
                                <img src=${escape(item.icon)} alt=${escape(
            item.name
          )}>
                            </span>
                            <span class="fillup-account__payment-method-item-text">${escape(
                              item.name
                            )}</span>
                        </div>
                    `;
        },
      },
      onChange(value) {
        if (value !== "prepaid") {
          $("#payment-extended-slider").removeClass("active");
          $("#paymentForm")
            .find('button[type="submit"]')
            .css("visibility", "visible");
        }
      },
    });
    $("#fillup-account-payment-method-selectized").attr("readonly", "readonly");
  };

  popupForm = () => {
    $("#property_quality").selectize();
    $("#property_callback_time").selectize();
    $("#property_was_useful").selectize();
    $("#property_operator_benevolence").selectize();
    $("#property_appeal_time").selectize();
    $("#property_communicated_with").selectize();

    $("#property_quality-selectized").attr("readonly", "readonly");
    $("#property_callback_time-selectized").attr("readonly", "readonly");
    $("#property_was_useful-selectized").attr("readonly", "readonly");
    $("#property_operator_benevolence-selectized").attr("readonly", "readonly");
    $("#property_appeal_time-selectized").attr("readonly", "readonly");
    $("#property_communicated_with-selectized").attr("readonly", "readonly");
  };

  formClear = () => {
    const qualityProperty = $("#property_quality").selectize();
    const callbackTimeProperty = $("#property_callback_time").selectize();
    const wasUsefulProperty = $("#property_was_useful").selectize();
    const operatorBenevolenceProperty = $(
      "#property_operator_benevolence"
    ).selectize();
    const appealTimeProperty = $("#property_appeal_time").selectize();
    const communicatedWith = $("#property_communicated_with").selectize();

    qualityProperty[0].selectize.clear();
    callbackTimeProperty[0].selectize.clear();
    wasUsefulProperty[0].selectize.clear();
    operatorBenevolenceProperty[0].selectize.clear();
    appealTimeProperty[0].selectize.clear();
    communicatedWith[0].selectize.clear();
  };

  userProfile = () => {
    $("#profile_sex").selectize();
    $("#profile_sex-selectized").attr("readonly", "readonly");
  };

  tvProgramPrint = (
    channelOptions,
    dateOptions,
    changeSelectedChannels,
    changeSelectedDates
  ) => {
    const selectors = {
      multipleSelect: ".multiple-select",
      input: ".selectize-input",
      close: ".selectize-close",
    };

    const activeClass = "active";
    const toggleSelectorState = ($selector) => {
      $selector.toggleClass(activeClass);
    };

    $("#print-channels").selectize({
      maxItems: null,
      plugins: [
        "multiple_select_remove_button",
        "multiple_select_toggle_option",
        "multiple_select_items_wrap",
      ],
      options: channelOptions,
      hideSelected: false,
      render: {
        option(item, escape) {
          return `
                        <div class="multiple-select-option option">
                            <div class="multiple-select-option__text">${escape(
                              item.name
                            )}</div>
                        </div>
                    `;
        },
        item(item, escape) {
          return `
                        <div class="item" data-value="${escape(
                          item.value
                        )}">${escape(item.name)}</div>
                    `;
        },
      },
      onItemRemove(value) {
        this.$dropdown.find(`[data-value="${value}"]`).removeClass("selected");
      },
    });

    $("#print-channels")[0].selectize.on("change", function () {
      changeSelectedChannels($("#print-channels")[0].selectize.getValue());
    });

    $("#print-dates").selectize({
      maxItems: null,
      plugins: [
        "multiple_select_remove_button",
        "multiple_select_toggle_option",
        "multiple_select_items_wrap",
      ],
      options: dateOptions,
      hideSelected: false,
      render: {
        option(item, escape) {
          return `
                        <div class="multiple-select-option option">
                            <div class="multiple-select-option__text">${escape(
                              item.name
                            )}</div>
                        </div>
                    `;
        },
        item(item, escape) {
          return `
                        <div class="item" data-value="${escape(
                          item.value
                        )}">${escape(item.name)}</div>
                    `;
        },
      },
      onItemRemove(value) {
        this.$dropdown.find(`[data-value="${value}"]`).removeClass("selected");
      },
    });

    $("#print-dates")[0].selectize.on("change", function () {
      changeSelectedDates($("#print-dates")[0].selectize.getValue());
    });

    $(selectors.close).on("click", function (e) {
      e.stopPropagation();
      const $this = $(this);
      const $selectorWrap = $this.closest(selectors.multipleSelect);
      const $correspondedSelectElem = $this
        .closest(selectors.multipleSelect)
        .find(selectors.input);

      if (!$selectorWrap.hasClass(activeClass)) {
        $correspondedSelectElem.trigger("click");
      } else {
        toggleSelectorState($selectorWrap);
      }
    });

    $(selectors.input).on("click", function (e) {
      e.stopPropagation();
      const $this = $(this);
      const $selectorWrap = $this.closest(selectors.multipleSelect);

      if ($selectorWrap.hasClass(activeClass)) {
        return;
      }

      toggleSelectorState($selectorWrap);
    });

    $(document).on("click", function () {
      const $selectorWraps = $(selectors.multipleSelect);
      $selectorWraps.removeClass(activeClass);
    });
  };
}

export const selects = new Select();
